import { SVGProps } from '@components/Icon/types';

export const Warning = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <path
      d="M9.65357 1.32393C9.80753 1.05726 10.1924 1.05726 10.3464 1.32393L18.5118 15.4668C18.6657 15.7334 18.4733 16.0668 18.1654 16.0668H1.8346C1.52668 16.0668 1.33423 15.7334 1.48819 15.4668L9.65357 1.32393Z"
      stroke={fill}
      strokeWidth="1.2"
    />
    <path
      d="M10.7003 6.19072C10.7003 5.80412 10.3869 5.49072 10.0003 5.49072C9.61368 5.49072 9.30028 5.80412 9.30028 6.19072V10.159C9.30028 10.5456 9.61368 10.859 10.0003 10.859C10.3869 10.859 10.7003 10.5456 10.7003 10.159V6.19072ZM9.99609 12.1749C9.44381 12.1749 8.99609 12.6226 8.99609 13.1749C8.99609 13.7272 9.44381 14.1749 9.99609 14.1749H10.0032C10.5555 14.1749 11.0032 13.7272 11.0032 13.1749C11.0032 12.6226 10.5555 12.1749 10.0032 12.1749H9.99609Z"
      fill={fill}
    />
  </svg>
);

export const ICON_NAME = 'warning';
